import { CellContext } from "@tanstack/react-table";

interface ThumbnailRendererProps<TData> {
  context: CellContext<TData, any>;
}

export const ThumbnailRenderer = <TData,>({
  context,
}: ThumbnailRendererProps<TData>) => {
  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent("shortsworks::dashboard::table::mounted", {
        detail: { context },
      }),
    );
  };

  return (
    <div
      className="cursor-pointer overflow-hidden rounded-sm"
      onClick={handleClick}
    >
      <img alt="" src={context.getValue()} style={{ width: "50px" }} />
    </div>
  );
};
